import axios from "axios";

const handleDownloadDocx = async (url: any) => {
    try {
      const response = await axios.get(url.replace("https://kmf-central.s3.ap-south-1.amazonaws.com", "https://uatapi-mfcentral.kfintech.com"), {
        responseType: "blob",
      });
      const contentType = response.headers["content-type"];
      const fileExtension = contentType === "application/msword" ? "doc" : "docx";
      const blob = new Blob([response.data], { type: contentType });
      const downloadUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `document_${Date.now()}.${fileExtension}`;
      link.click();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  export default handleDownloadDocx;